<template>
    <div v-if="variant === VARIANT.DETAILED" class="interactive-info--detailed">
        <CompassTooltip :content="tooltipText">
            <div
                v-if="type === TYPE.EMAIL"
                :class="textClasses"
                class="interactive-info__email-button"
                @click="sendEmail"
            >
                {{ getLabel(values[0]) }}
            </div>
            <a v-else :class="textClasses" :href="getLink(values[0])" @click.stop>
                {{ getLabel(values[0]) }}
            </a>
        </CompassTooltip>
    </div>
    <div v-else class="interactive-info--icons">
        <div v-if="type !== TYPE.EMAIL && values.length > 1">
            <CompassMenu customClass="menu-phone" size="small" placement="bottom">
                <CompassIconButton :size="size" icon="phone" />
                <template slot="dropdown">
                    <CompassMenuSubtitle :label="tooltipText" />
                    <a
                        v-for="(phoneNumber, index) in values"
                        :key="index"
                        class="typographies-paragraph-small-regular interactive-info--link"
                        :href="getLink(phoneNumber)"
                    >
                        {{ getLabel(phoneNumber) }}
                    </a>
                </template>
            </CompassMenu>
        </div>

        <CompassTooltip v-if="type === TYPE.EMAIL" :content="tooltipText">
            <CompassIconButton icon="email" :size="size" @click.stop="sendEmail" />
        </CompassTooltip>
    </div>
</template>

<script>
const VARIANT = Object.freeze({
    DETAILED: 'detailed',
    ICONS: 'icons',
});
const TYPE = Object.freeze({
    MOBILE: 'mobile',
    PHONE: 'phone',
    EMAIL: 'email',
});
const SIZE = Object.freeze({
    EXTRA_SMALL: 'extra-small',
    SMALL: 'small',
});

const { mapState } = createNamespacedHelpers('corp');
import { formatPhoneNumber } from 'filters/vue_filters.js';
import { createNamespacedHelpers } from 'vuex';

export default {
    props: {
        type: {
            type: String,
            default: 'phone',
        },
        size: {
            type: String,
            default: 'small',
            validator: (value) => [SIZE.EXTRA_SMALL, SIZE.SMALL].includes(value),
        },
        values: {
            type: Array,
            default: () => [],
        },
        variant: {
            type: String,
            default: 'detailed',
        },
    },
    data() {
        return {
            VARIANT,
            TYPE,
        };
    },
    computed: {
        ...mapState({
            phoneFormat: 'phoneFormat',
            phoneCallProtocol: 'phonecallProtocol',
        }),
        textClasses() {
            return [
                this.size === SIZE.EXTRA_SMALL ? 'typographies-paragraph-small-regular' : '',
                this.size === SIZE.SMALL ? 'typographies-paragraph-medium-regular' : '',
                'interactive-info--link',
            ];
        },
        tooltipText() {
            return this.type === TYPE.EMAIL
                ? this.$t.__('common.actions.send_email')
                : this.$t.__('common.actions.start_call');
        },
    },
    methods: {
        getLabel(value) {
            if (this.type === TYPE.EMAIL) {
                return value;
            } else {
                return formatPhoneNumber(value, this.phoneFormat);
            }
        },
        getLink(value) {
            if (this.type === TYPE.EMAIL) {
                return `mailto:${value}`;
            } else {
                return `${this.phoneCallProtocol}:${value}`;
            }
        },
        sendEmail() {
            this.$emit('sendEmail', this.values[0]);
        },
    },
};
</script>

<style scoped lang="scss">
.interactive-info {
    &--detailed,
    &--icons {
        .interactive-info--link {
            color: var(--colors-component-text-navigation-default);
            &:hover {
                color: var(--colors-component-text-navigation-hover-alt);
            }
        }
    }
    &__email-button {
        cursor: pointer;
    }
}
</style>
<style lang="scss">
#compass-menu-container {
    .menu-phone {
        .interactive-info--link {
            padding: var(--spacing-0);
            color: var(--colors-component-text-navigation-default);
            &:hover {
                color: var(--colors-component-text-navigation-hover-alt);
            }
        }
    }
}
</style>
